/* 지도 위 랜덤 — 주사위와 화면틀 한 쌍.
 *
 * 랜덤은 지도 위에 산다. 왼쪽 툴바에 있던 시절에는 '점심만·찜' 옆이라 목록 필터로
 * 읽혔고, 범위를 정하는 손잡이를 붙여도 그게 랜덤의 옵션이라는 걸 아무도 눈치채지
 * 못했다. 지도 위로 오면 버튼이 놓인 자리가 곧 설명이다 — 보고 있는 이 화면에서 뽑는다.
 *
 * 화면틀을 켜면 (1) 지금 보이는 곳에서만 뽑고 (2) 당첨돼도 지도를 안 옮긴다.
 * 화면이 그대로 남아야 마음에 안 들 때 곧바로 다시 돌릴 수 있다. 드래그·줌은 막지
 * 않는다 — 다른 동네를 보려면 지도를 끌어야 하고, 그 행동이 곧 다음 판의 범위를
 * 고르는 일이다. 고정할 게 있다면 '앱이 마음대로 옮기는 것'이지 사용자의 손이 아니다.
 */

import { SquareDashed } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Toggle } from "@/components/ui/toggle";

import { cn } from "../lib/util.js";
import { FLOAT_BTN, FLOAT_ON } from "./Overlays.jsx";

export function RandomButton({ onSpin, spinning, locked }) {
  return (
    <Button
      aria-label="랜덤"
      className={cn(FLOAT_BTN, "size-10 rounded-full text-lg",
                    spinning && "spinning cursor-default border-primary hover:bg-background")}
      id="btn-random"
      onClick={onSpin}
      size="icon-lg"
      title={locked ? "보이는 곳 중에서 한 곳" : "아무 데나 한 곳"}
      variant="ghost"
    >
      <span className={cn("dice inline-block leading-none", spinning && "animate-dice-roll")}>
        🎲
      </span>
    </Button>
  );
}

export function LockButton({ locked, onChange }) {
  return (
    <Toggle
      aria-label="지도 고정"
      /* 그림만으로는 무엇이 고정되는지 알 수 없다. 지금 상태가 아니라 누르면 무슨 일이
         생기는지를 적는다 — 켜고 끄는 버튼의 설명은 그쪽이 쓸모 있다. */
      title={locked
        ? "지도 고정 해제 — 목록 전체에서 뽑고, 당첨된 곳으로 지도가 따라갑니다"
        : "지도 고정 — 보이는 곳에서만 뽑고, 당첨돼도 화면이 움직이지 않습니다"}
      className={cn(FLOAT_BTN, FLOAT_ON, "size-10 rounded-full text-muted-foreground")}
      id="btn-lock"
      onPressedChange={onChange}
      pressed={locked}
    >
      {/* 자물쇠가 아니라 화면틀이다. 고정되는 건 지도가 아니라 '뽑는 범위'고, 그건
          지금 보이는 네모 그 자체다 — 자물쇠는 드래그까지 막힌다고 읽힌다.
          켜고 꺼도 그림은 그대로 두고 파랗게 차는 것으로만 말한다. 상태마다 다른
          아이콘을 쓰면 같은 버튼이 두 개처럼 보여서 무엇이 켜진 모양인지 흐려진다. */}
      <SquareDashed className="size-[18px]" />
    </Toggle>
  );
}
